import { images } from './images';
import type { Teacher, Testimonial } from '../types/content';

export const testimonials: Testimonial[] = [
  {
    name: 'Lucas',
    detail: 'General English student',
    avatar: images.avatar1,
    quote: 'I was nervous on my first day, but my teacher helped me speak from the first lesson. After a few weeks I could talk with my colleagues in English without stress.',
  },
  {
    name: 'Mei',
    detail: 'IELTS Preparation student',
    avatar: images.avatar2,
    quote: 'The practice tests showed me what to work on each week. My teacher marked my essays and explained every mistake in a clear way.',
  },
  {
    name: 'Omar',
    detail: 'Business English student',
    avatar: images.avatar3,
    quote: 'We practised real meetings and emails. I used the same phrases at work the next week.',
  },
  {
    name: 'Ana',
    detail: 'Parent of a Language Camp student',
    quote: 'My child came home more confident and with friends from many countries. The daily updates helped me feel calm.',
  },
  {
    name: 'Kenji',
    detail: 'Speaking Class student',
    quote: 'In my country I studied grammar for years but never spoke. Here I speak in every lesson, and now I enjoy it.',
  },
  {
    name: 'Sofia',
    detail: 'Accommodation guest',
    quote: 'My studio was clean, modern and close to school. The team answered my questions quickly and helped me on my first day.',
  },
];

export const teachers: Teacher[] = [
  {
    name: 'Ryan Hannan',
    role: 'Global Academic Director',
    qualifications: 'CELTA trainer, 20+ years in teaching',
    bio: 'Ryan has taught in Taiwan, Spain and London. He leads our academic teams and trains new teachers on the CELTA course.',
  },
  {
    name: 'Taghrid Ahmed',
    role: 'Senior Teacher, Curriculum & Teacher Training · London',
    qualifications: 'DELTA, CELTA trainer',
    bio: 'Taghrid has taught in Dubai, Saudi Arabia and the UK. She shapes our curriculum and also works as a university counsellor for students.',
  },
  {
    name: 'Robert Saunders',
    role: 'Teacher · Dubai',
    qualifications: 'CELTA, MA in Linguistics',
    bio: 'Robert brings experience in academic management and as a Cambridge exam examiner, helping students understand exactly what each task asks for.',
  },
  {
    name: 'Benjamin James',
    role: 'Assistant Director of Studies · London',
    qualifications: 'CELTA, ~20 years in teaching',
    bio: 'Benjamin taught in Japan and Italy before joining our London team, where he supports teachers and keeps lessons focused on learners.',
  },
  {
    name: 'Tom Hudd',
    role: 'Teacher · Dubai',
    qualifications: 'CELTA, 12 years in teaching',
    bio: 'Tom is also a cross-cultural competence trainer and helps students communicate confidently with people from every background.',
  },
  {
    name: 'Gemma McGeehan',
    role: 'Teacher · Dubai',
    qualifications: 'CELTA, 7 years in teaching',
    bio: 'Originally from Bath, Gemma has lived in Dubai for over 20 years and knows the city as well as she knows the classroom.',
  },
];
